import { render } from "./discount_form.vue?vue&type=template&id=4f176e6c"
import script from "./discount_form.vue?vue&type=script&lang=js"
export * from "./discount_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__